import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { shopStore } from '@/stores';
import { vfsRoutes } from '@/constants/routes.constants';

type ComponentProps = { children: React.ReactNode };

const RequireLiveFeatureEnabled = ({ children }: ComponentProps) => {
    const shopStoreSnap = useSnapshot(shopStore);
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const redirectTo = vfsRoutes.landing;

    useEffect(() => {
        if (
            !shopStoreSnap.enabledFeatures.includes('live') &&
            pathname !== redirectTo
        ) {
            navigate(redirectTo);
        }
    }, [shopStoreSnap.enabledFeatures]);

    return <>{children}</>;
};

export default RequireLiveFeatureEnabled;
